import AskMeAnythingImage from '../../public/images/AskMeAnything.jpg';
import ServiceProblemsImage from '../../public/images/ServiceProblems.jpg';
import AllThingsXfinityImage from '../../public/images/AllThingsXfinity.jpg';

const carouselsXA3 = [
    {
        title: 'Ask me anything',
        img: 'Payment',
        imgURL: AskMeAnythingImage,
        description:
            'You can describe any Xfinity issue you’re having, or just ask a question, like “How do I pay my bill?” And if for some reason I can’t give you the answer, I’ll connect you to agent who can.',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'Ask',
        linkText: 'Ask Xfinity',
    },
    {
        title: 'Service problems?',
        img: 'Restart',
        imgURL: ServiceProblemsImage,
        description:
            'Describe an issue you’re having like, “I need to restart my modem” or “What’s going on with my internet connection?” if I can’t resolve it, I can connect you with a live agent who can.\n',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'Start',
        linkText: 'Start troubleshooting',
    },
    {
        title: 'All things Xfinity',
        img: 'Pods',
        imgURL: AllThingsXfinityImage,
        description:
            'I’m there for you whenever and wherever with any of your Xfinity products or services. from recording your favorite shows on your X1 DVR to updating you on your package delivery, I got you covered.',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'DoYou',
        linkText: 'How can I help?',
    },
];

export default carouselsXA3;
